export type Project = {
  slug: string;
  num: string;
  title: string;
  type: string;
  category: "Whole Home" | "Kitchen" | "Bathroom" | "Addition";
  location: string;
  year: string;
  image: string;
  secondaryImage: string;
  detailImages: string[];
  materialImage: string;
  overview: string;
  challenge: string;
  approach: string;
  description: string;
};

export const projects: Project[] = [
  {
    slug: "ridge-house",
    num: "001",
    title: "Ridge House",
    type: "Whole Home Renovation",
    category: "Whole Home",
    location: "Los Angeles, California",
    year: "2025",
    image: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-hero.webp",
    secondaryImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-living-dining.webp",
    detailImages: [
      "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-hallway.webp",
      "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-dining.webp",
    ],
    materialImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-kitchen.webp",
    overview: "A hillside residence reimagined around light, view and quiet materiality — white oak, travertine and honed limestone composed into a calm daily rhythm.",
    challenge: "The original plan divided the home into small compartments that fought the site. Structural walls limited both light and view.",
    approach: "We reorganized the ground floor around a continuous stone spine, opened the canyon-facing elevation, and resolved every material transition in millwork rather than trim.",
    description: "A calm, considered whole-home renovation.",
  },
  {
    slug: "oakline-kitchen",
    num: "002",
    title: "Oakline Kitchen",
    type: "Kitchen Renovation",
    category: "Kitchen",
    location: "Pasadena, California",
    year: "2025",
    image: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-oakline-kitchen-hero.webp",
    secondaryImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-oakline-kitchen-alt.webp",
    detailImages: [
      "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-oakline-kitchen-detail.webp",
    ],
    materialImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-oakline-kitchen-detail.webp",
    overview: "A working family kitchen anchored by a single travertine island — quiet oak cabinetry, honed stone and brass fittings tuned to daily use.",
    challenge: "The existing kitchen isolated the cook from the family and lost the garden view behind upper cabinetry.",
    approach: "A single island replaces the fragmented run. Storage moves into a concealed pantry so the room reads as one calm architectural volume.",
    description: "A quiet, hardworking family kitchen.",
  },
  {
    slug: "stonewell-bath",
    num: "003",
    title: "Stonewell Bath",
    type: "Primary Bathroom Renovation",
    category: "Bathroom",
    location: "Ojai, California",
    year: "2024",
    image: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-stonewell-bath-hero.webp",
    secondaryImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-stonewell-bath-alt.webp",
    detailImages: [
      "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-stonewell-bath-detail.webp",
    ],
    materialImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-stonewell-bath-detail.webp",
    overview: "A primary bath resolved as one continuous stone volume — freestanding tub, warm oak vanity and diffused daylight shaping a slow, restorative room.",
    challenge: "A dated compartmentalized layout with poor daylight and cold surfaces that felt disconnected from the rest of the home.",
    approach: "We rebuilt the room as a single honed-limestone envelope, reintroduced daylight through a clerestory, and warmed every touchpoint with oak and textile.",
    description: "A restorative stone bathroom.",
  },
];

export const getProject = (slug: string) => projects.find(p => p.slug === slug);